<template>
    <div class="simple_filter">
        <div
            v-if="is_initialized"
            @keypress.enter="$parent.core_waybills_filter()"
            class="right aligned"
            style="text-align:right">

            <div class="ui right labeled input"
                style="display: inline-flex;">
                <input
                    @change="$forceUpdate()"
                    v-model="filter[quick_filter_key.info]"
                    :placeholder="$t('ui.pages.core_waybills.filter.find__key', {
                        key: $t('models.attributes.core_waybills.'+quick_filter_key.info)
                    })"
                    type="text"
                >
                <div class="ui dropdown label no_search" v-dropdown>
                    <div class="text"
                        v-for="item in quick_filters.info"
                        v-if="quick_filter_key.info == item">
                        {{ $t('models.attributes.core_waybills.'+item) }}
                    </div>
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div class="item"
                            v-for="item in quick_filters.info"
                            v-if="item != 'divider'"
                            :class="{'selected active': quick_filter_key.info == item}"
                            @click="$parent.set_quick_filter_key('info', item)"
                            >
                            {{ $t('models.attributes.core_waybills.'+item) }}
                        </div>
                        <div v-else class="divider" style="margin: 0.2em 0;">
                        </div>
                    </div>
                </div>
            </div>

            <span class="depiction">&nbsp;</span>
            <div v-dropdown class="ui fluid selection dropdown" style="width:120px;">
                <div
                    class="text"
                    v-for="status_scope_selection in ['operator','forwarder','public']"
                    v-if="filter.status.scope == status_scope_selection">
                    {{ $t("ui.status_scopes."+status_scope_selection) }}
                </div>
                <div v-if="filter.status.scope == null">
                    {{ $t('ui.pages.core_waybills.filter.selected_status_scope') }}
                </div>
                <i class="dropdown icon"></i>
                <div class="menu">
                    <div class="item"
                        @click="filter.status.scope = null"
                        :class="{'selected active': filter.status.scope == null }"
                    >
                        {{ $t('ui.pages.core_waybills.filter.selected_status_scope') }}
                    </div>
                    <div
                        v-for="status_scope_selection in ['operator','forwarder','public']"
                        @click="filter.status.scope = status_scope_selection"
                        class="item"
                        :class="{
                            'selected active': filter.status.scope == status_scope_selection
                        }">
                        {{ $t("ui.status_scopes."+status_scope_selection) }}
                    </div>
                </div>
            </div>
            <span class="depiction">&nbsp;</span>
            <div v-dropdown class="ui fluid selection dropdown" style="width:240px;">
                <div
                    class="text"
                    v-for="(scan_action_prototype, index) in scan_action_prototypes"
                    v-if="filter.status.name == scan_action_prototype.name">
                    {{ scan_action_prototype.name }}
                </div>
                <div v-if="filter.status.name == null">
                    {{ $t('ui.pages.core_waybills.filter.selected_status') }}
                </div>
                <i class="dropdown icon"></i>
                <div class="menu">
                    <div class="item"
                        @click="filter.status.name = null"
                        :class="{'selected active': filter.status.name == null }"
                    >
                        {{ $t('ui.pages.core_waybills.filter.selected_status') }}
                    </div>
                    <div
                        v-for="(scan_action_prototype, index) in scan_action_prototypes"
                        @click="filter.status.name = scan_action_prototype.name"
                        class="item"
                        :class="{
                            'selected active': filter.status.name == scan_action_prototype.name
                        }">
                        {{ scan_action_prototype.name }}
                    </div>
                </div>
            </div>

        </div>
        <div class="ui active centered inline loader" v-else></div>
    </div>
</template>

<script>

export default {
    props: {
    },
    data() {
        return {
            is_show_numbers: true,
            is_show_info: true,
            is_show_status: true,
            is_initialized: false,
            is_processing: false,
            filter_is_useds: [
                {name: this.$t('ui.pages.core_waybills.filter.is_used.flase'), boolean: 'false'},
                {name: this.$t('ui.pages.core_waybills.filter.is_used.true'), boolean: 'true'},
            ],
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.core_waybills_module
        },
        is_show_filter() {
            return this.current_store.is_show_filter
        },
        quick_filters() {
            return this.current_store.quick_filters
        },
        quick_filter_key() {
            return this.current_store.quick_filter_key
        },
        filter() {
            return this.current_store.filter
        },
        staffs() {
            return [{
                name: this.$t('ui.pages.core_waybills.filter.selected_staff'),
                identity: null,
            }].concat(this.current_store.staffs)
        },
        stations() {
            return [{
                name: null,
                identity: null,
            }].concat(this.$store.state.provider.stations)
        },
        materials() {
            return [{
                name: this.$t('ui.pages.core_waybills.filter.selected_material'),
                class_name: null,
            }].concat(this.current_store.materials)
        },
        scan_action_prototypes() {
            return this.current_store.scan_action_prototypes
        },
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        set_is_used(boolean = null) {
            this.filter.is_used = (this.filter.is_used == boolean) ? null : boolean
            if (this.filter.is_used == null) {
                $(this.$refs.filter_is_used).checkbox('uncheck')
            }
        },
    },
    components: {
    },
}
</script>
<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
</style>
<style scoped lang="scss">
    .simple_filter {
        .ui.input:not(.dont_inline),
        .ui.dropdown:not(.dont_inline) {
            display: inline-block;
        }
    }
    .filter_border {
        border: 0.5px #666 solid;
        margin: 12px 0;
    }
    .sub_filter_border {
        border: 0.5px #999 dashed;
        margin: 12px 0;
    }
    .status_filter {
        .depiction {
            display: inline-block;
            margin: 0px;
        }
        .depiction + div {
            display: inline-block;
            margin-bottom: 6px;
        }
    }
    .ui.list .item {
        & {
            padding-bottom: 9px;
        }
        .content {
            & {
                width: 100%;
            }
            .header {
                margin-bottom: 6px;
            }
        }
    }

    .ui.form .field {
        &.red input {
            border-top: 2px solid #db2828!important;
        }
        &.orange input {
            border-top: 2px solid #f2711c!important;
        }
        &.olive input {
            border-top: 2px solid #b5cc18!important;
        }
        &.green input {
            border-top: 2px solid #21ba45!important;
        }
        &.teal input {
            border-top: 2px solid #00b5ad!important;
        }
        &.blue input {
            border-top: 2px solid #2185d0!important;
        }
        &.violet input {
            border-top: 2px solid #6435c9!important;
        }
        &.purple input {
            border-top: 2px solid #a333c8!important;
        }
        &.grey input {
            border-top: 2px solid #767676!important;
        }
    }
</style>
